import {ILocalVideoTrack, IRemoteVideoTrack, ILocalAudioTrack, IRemoteAudioTrack} from "agora-rtc-sdk-ng";
import React, {useRef, useEffect} from "react";
import {makeStyles, Theme} from "@material-ui/core/styles";

const useStyle = makeStyles((theme: Theme) => ({
    myVideo: {
        width: 200,
        height: 150,
        backgroundColor: "#000",
        [theme.breakpoints.down("xs")]: {
            // top: "22%",
            position: "fixed",
            maxHeight: "30%",
            bottom: "20px",
            // margin: "49vh 0 0 auto",
        }
    },
    incomminVideo: {
        objectFit: "cover",
        width: "80%",
        height: "auto",
        backgroundColor: "#000",
        "& .agora_video_player": {
            position: "static !important",
        }
    },
}));

const vetStyle = makeStyles((theme: Theme) => ({
    myVideo: {
        width: 200,
        position: "absolute",
        zIndex: 100,
        minHeight: 150,
        height: 150,
        top: "6.25%",
        backgroundColor: "#000",
        [theme.breakpoints.down("xs")]: {
            position: "fixed",
            width: "40vw",
            height: "auto",
            margin: "49vh 0 0 auto",
            left: "1%",
            // transform: "translateX(-50%)",
        }
    },
    incomminVideo: {
        objectFit: "cover",
        width: "100%",
        // height: 150,
        backgroundColor: "#000",
        "& .agora_video_player": {
            position: "static !important",
        }
    },
    fullscreen: {
        width: "80%",
    }
}));

export interface VideoPlayerProps {
    videoTrack: ILocalVideoTrack | IRemoteVideoTrack | undefined;
    audioTrack: ILocalAudioTrack | IRemoteAudioTrack | undefined;
    isVet?: boolean,
    aloneInRoom?: boolean,
    ownVideo?: boolean,
    fullscreen?: boolean,
}

const MediaPlayer = ({videoTrack, audioTrack, isVet, aloneInRoom = true, ownVideo = true, fullscreen}: VideoPlayerProps) => {
    const container = useRef<HTMLDivElement>(null);
    const classes = useStyle();
    const vetClasses = vetStyle();

    useEffect(() => {
        if (!container.current) return;
        videoTrack?.play(container.current);
        return () => {
            videoTrack?.stop();
        };
    }, [container, videoTrack]);

    useEffect(() => {
        if (audioTrack) {
            audioTrack?.play();
        }
        return () => {
            audioTrack?.stop();
        };
    }, [audioTrack]);
    return (
        <div ref={container}
            id={ownVideo ? "own-video" : "remote-video"}
            className={ownVideo && !aloneInRoom ? (isVet ? vetClasses.myVideo : classes.myVideo) : (isVet ? `${vetClasses.incomminVideo} ${fullscreen && vetClasses.fullscreen}` : classes.incomminVideo)}
        />
    );
};

export default MediaPlayer;
